import { useState } from "react";
import { Link } from "react-router-dom";

const KEY = "pc-cookie-hinweis";

export const CookieNotice = () => {
  const [show, setShow] = useState(() => !localStorage.getItem(KEY));
  if (!show) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:max-w-md z-50 bg-navy text-paper p-6 shadow-2xl" data-testid="cookie-notice">
      <p className="text-sm leading-relaxed">
        Diese Website verwendet keine Tracking- oder Werbe-Cookies und keine Google-Dienste. Mehr dazu in der{" "}
        <Link to="/datenschutz" className="underline hover:text-plate-light" data-testid="cookie-privacy-link">Datenschutzerklärung</Link>.
      </p>
      <button type="button" onClick={close} className="lb mt-4 bg-plate text-white px-5 py-3 transition-colors hover:bg-plate-hover" data-testid="cookie-accept-btn">
        Verstanden
      </button>
    </div>
  );
};
